import { render, staticRenderFns } from "./OverviewHostingInstitution.vue?vue&type=template&id=bad0168c"
import script from "./OverviewHostingInstitution.vue?vue&type=script&lang=js"
export * from "./OverviewHostingInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports